PJQ.views.commitments.BaseDataTable = PJQ.views.dataTables.DataTable.extend({
	defaults: {
		language: {
			zeroRecords: "No Results Available"
		},
		isHideSearch: true,
		dom: '<"top"p<"clear">>rt<"bottom"p<"clear">>'
	},
	events: {
		'click .btn-copy-phone': 'copyPhone',
		'click .btn-copy-fax': 'copyPhone',
		'click .btn-copy-cell': 'copyPhone',
		'click .btn-copy-email': 'copyEmail'
	},
	beforeDataTableRender: function () {
		let self = this;
		this.options.rowCallback = function (row, data) {
		};

		this.options.childDataTables = [];

		this.options.contextMenuOptions = {
			actions: this.getContextMenuItems(),
			isHideNoActions: true
		};

		if(this.options.onRowDoubleClick == null){
			this.options.onRowDoubleClick = _.bind(function (row) {
				if (row.data()) {
					this.editRow(row);
				}
			}, this);
		}

		if (this.options.settings) {
			// enable paging for grids that have a setting for it / are not subgrids
			if (this.options.settings.rowsPerPage !== 0 && this.options.view.indexOf('-') === -1)
				this.options.pageLength = this.options.settings.rowsPerPage;
			else
				this.options.pageLength = 2147483646;

			if (this.options.settings.orderBy !== 'sortOrder') {
				if (_.size(this.options.settings.columns) === 0) {
					if (_.size(this.options.settings.columnsDefault) > 0) {
						this.options.settings.orderBy = this.options.settings.columnsDefault[0];
					}
				}
				else if (this.options.settings.columns.indexOf(this.options.settings.orderBy) === -1) {
					this.options.settings.orderBy = this.options.settings.columns[0];
				}
			}
			_.each(this.getColumns(false, this.options.view), _.bind(function (column, index) {
				if (column.columnData === this.options.settings.orderBy) {
					this.options.order = [[index, this.options.settings.orderAscending ? 'asc' : 'desc']];
				}
			}, this));

			let fixedColumnsLeft = 0;
			this.options.colReorder = {
				fixedColumnsLeft: fixedColumnsLeft,
				realtime: false
			};
		}

		this.options.createdRow = _.bind(this.createdRow, this);

		if (typeof this.options.beforeDataTableRender === 'function') {
			this.options.beforeDataTableRender();
		}
	},
	orderByChanged: function () {
	},
	afterDataTableRenderChild: function () {
	},
	getRowChildTable: function (childOpts) {
	},
	getRowChildData: function (row) {
	},
	setRowStyle: function (row, status, isBlacklisted) {
	},
	getContextMenuItems: function () {
	},
	editRow: function (row) {
	},
	statusChanged: function (statuses) {
	},
	getColumns: function () {
	},
	cleanup: function () {
		this.undelegateEvents();
		$(this.el).empty();
	},
	getIsRootView: function () {
		return (this.options.view.indexOf('-') === -1);
	},
	createdRow: function (row, data, dataIndex) {
	}
});